import { z } from 'zod';
import { notificationContentSchema } from './schema';

/** The exact provider payload, or the explicit reason capture could not validate it. */
export const dispatchedPushContentSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('captured'), copy: notificationContentSchema }).strict(),
  z.object({ status: z.literal('unavailable'), reason: z.literal('capture_invalid') }).strict(),
]);
export type DispatchedPushContent = z.infer<typeof dispatchedPushContentSchema>;

/** Bookkeeping must survive invalid copy after a push has already left. */
export function captureDispatchedPushContent(value: unknown): DispatchedPushContent {
  const copy = notificationContentSchema.safeParse(value);
  return copy.success
    ? { status: 'captured', copy: copy.data }
    : { status: 'unavailable', reason: 'capture_invalid' };
}

/** Shared writer/reader fixture, kept beside the owning stored-payload schema. */
export function dispatchedPushContentFixture(
  copy: z.infer<typeof notificationContentSchema> = {
    title: 'A moment for today',
    body: 'You can track how today went whenever you want.',
  },
) {
  return { status: 'captured', copy } satisfies DispatchedPushContent;
}
